import { IEnvironment } from '@scientificnet/cockpit-core';

export const host = 'https://webservices-test.scientificnet.org/';
export const hostApi = 'https://api-test.scientificnet.org/';
export const domain = 'https://my-test.scientificnet.org/';
export const imagesUrl = domain + 'public/assets/latest/img/';
export const packageJson = require('./../../package.json');

export interface IExtendedEnvironment extends IEnvironment {
  todosRetrievalMethod: 'CUSTOM' | 'STANDARD';
  testerUpns: string[];
}

export const environment: IExtendedEnvironment = {
  production: false,
  name: 'test',
  version: packageJson.version,
  dependencies: packageJson.dependencies,
  host,
  domain,
  appName: 'Home',
  administrators: [
    'lkarolak@unibz.it',
    'pfilloramo@unibz.it',
    'alestan@eurac.edu',
    'cdelsante@unibz.it',
    'ykomemi@eurac.edu',
    'vamarsich@eurac.edu',
    'mamerlin@unibz.it',
  ],
  testerUpns: [
    'mperathoner@unibz.it',
    'wmores@unibz.it',
    'sfurggler@unibz.it',
    'pbuoso@unibz.it',
    'lsiciliano@unibz.it',
    'fvisciglia@unibz.it',
    'apircher@unibz.it',
  ],
  webservices: {
    microsoftGraph: {
      host: 'https://graph.microsoft.com/v1.0',
      isProtected: true,
      impersonate: false,
    },
    cockpitMobile: {
      host: host + 'rest/cm',
      isProtected: true,
      impersonate: true,
    },
    centralpoint: {
      host: host + 'rest/cpos/api/CPOS',
      impersonate: true,
      isProtected: true,
    },
    snsGraphApi: {
      host: hostApi + 'graph/api',
      isProtected: true,
      impersonate: true,
    },
    dynamicsEuracHr: {
      host: hostApi + 'd365-proxy',
      isProtected: true,
      impersonate: false,
    },
    teamsProxyApi: {
      host: host + 'rest/teamsproxy/api/token',
      isProtected: true,
      impersonate: true,
    },
    ineproApi: {
      host: 'https://webservices-test.scientificnet.org/rest/inepro',
      isProtected: true,
      impersonate: false,
    },
    notificationsApi: {
      host: hostApi + 'notifications',
      impersonate: false,
      isProtected: true,
    },
  },
  authConfig: { clientId: '059be839-76ab-49c9-af62-91f33d17707a' },
  appInsights: {
    instrumentationKey: '4975a59e-eb91-4eb2-8959-e8b280697656',
  },
  todosRetrievalMethod: 'STANDARD',
  scientificnetApplicationId: '92614',
  ticketQueueId: 1,
};
